module.exports = __webpack_public_path__ + "media/images/furight-d9b114fb10238053e49f77a14814b3e0.jpg";